<template>
    <div class="tile-list">
        <div class="tile-list__header" v-if="(showTitle || showThumbnailSlider) && !hideForScreenshot">
            
            <a class="header__auth__user view__title tile-list__title" 
                v-on:click="toggleStartdesksNav" 
                v-on-clickaway="closeStartdesksNav"
                v-if="showTitle && startdesks && startdesks.length > 0">
                <span>{{ __('My Startdesks') }}</span>
            </a>
            <nav class="header__auth__nav bbrc-left" v-bind:class="{ 'is-active' : isStartdesksNavActive }">
                <router-link class="header__auth__nav__manage-startdesks"
                             v-for="startdesk in startdesks" 
                             v-bind:to="{ name: 'startdesks.view', params: { startdesk: startdesk.slug, u: startdesk.is_user_startdesk } }"
                             :key="startdesk.id">{{ startdesk.name }}</router-link>
            </nav>
            
            <h1 class="view__title tile-list__title"
                v-html="(showTitle && startdesks && startdesks.length > 0 ? ' ::   ' : '') + __(':startdesk Startdesk', startdesk.name)"
                v-if="showTitle"
            ></h1>

            <router-link class="startdesk__action startdesk__action--edit has-margin-l10    "
                        v-bind:to="{ name: 'startdesks.edit', params: { startdesk: startdesk.id } }"
                        v-if="user && startdesk && (user.is_admin || user.id === startdesk.user_id)"
            >
                <span class="jam jam-pencil"></span>
            </router-link>
            
            <button class="btn is-primary startdesk__add-btn has-margin-l10" type="button"
                    v-if="user && startdesk && user.id !== startdesk.user_id"
                    v-on:click="handleAddToMyStartdesks"
            >
                {{ __('Add to my startdesks') }}
            </button>

            <div class="tile-list__size-control" v-if="showThumbnailSlider && tiles && tiles.length > 0">
                <span class="tile-list__size-control__label">{{ __('Thumbnail size') }}:</span>

                <input type="range" min="80" max="180" v-model.number="tileWidth" />
            </div>
        </div>

        <div class="filters tile-list__filters" v-if="showFilters && !hideForScreenshot">
            <div class="category-list">
                <router-link class="category-list__item"
                             v-bind:to="{ name: 'tiles.add' }"
                             v-if="showBackButton"
                >
                    {{ __('Back') }}
                </router-link>
            </div>

            <category-list category-type="tiles"
                           v-bind:list-link="{ name: 'tiles.add' }"
                           v-bind:parent-id="category"
                           v-if="showFilters['category'] && listType == 'add'"
            />

            <category-list category-type="tiles"
                           v-bind:active-category="categoryFilter"
                           v-bind:parent-category-name="categoryFilter"
                           v-bind:parent-id="categoryFilter"
                           v-bind:show-all="true"
                           v-if="showFilters['category'] && listType == 'list'"
            />

            <div class="form is-horizontal">
                <div class="form__group" v-if="showFilters['created_at']">
                    <label class="form__label" for="creation_date">{{ __('Date created') }}</label>
                    <v-date-picker mode="range" show-caps
                                   v-bind:input-props="{ 'class' : 'form__control', 'id' : 'creation_date', placeholder: __('Choose dates') }"
                                   v-model="createdAt"
                                   v-on:input="getTiles(true)"
                            >
                    </v-date-picker>
                </div>

                <div class="form__group" v-if="showFilters['updated_at']">
                    <label class="form__label" for="update_date">{{ __('Last updated') }}</label>
                    <v-date-picker mode="range" show-caps
                                   v-bind:input-props="{ 'class' : 'form__control', 'id' : 'update_date', placeholder: __('Choose dates') }"
                                   v-model="updatedAt"
                                   v-on:input="getTiles(true)"
                            >
                    </v-date-picker>
                </div>
            </div>

            <div class="form is-horizontal">
                <div class="form__group" v-if="showFilters['search']">
                    <label class="form__label" for="search" autocomplete="off">{{ __('Search') }}</label>
                    <input class="form__control" id="search"
                           v-model="search"
                           v-on:change="getTiles(true)"
                            />
                </div>

                <div class="form__group" v-if="showSort">
                    <label class="form__label" for="sort">{{ __('Sort by') }}</label>
                    <select class="form__control" id="sort"
                            v-model="sort"
                            v-on:change="getTiles(true)"
                            >
                        <option value="name_asc">Name (A-Z)</option>
                        <option value="name_desc">Name (Z-A)</option>
                        <option value="created_at">Date created</option>
                        <option value="updated_at">Last updated</option>
                    </select>
                </div>
            </div>
        </div>

        <router-link class="btn has-margin-b30 is-pulled-left is-primary"
                     v-bind:to="{ name: 'tiles.add', params: {category: this.startdesk ? null : 'admin'} }"
                     v-if="listType == 'list' && user && user.is_admin"
        >
            <span class="jam jam-plus"></span> {{ __('Add tile') }}
        </router-link>

        <nav class="tile-list__tiles">
            <router-link class="tile-list__add-tile"
                         v-bind:style="tileProperty"
                         v-bind:to="{ name: 'tiles.add', params: { startdesk: startdesk.id  } }"
                         v-if="user && startdesk && (user.is_admin || user.id === startdesk.user_id) && showAddButton"
            >
                <span class="jam jam-plus-circle"></span>
                <h2 class="view__title startdesk-list__title" style="text-align: center;">Add new tile</h2>
            </router-link>
            
            <tile v-bind:draggable="sortable"
                  v-bind:key="tile.id"
                  v-bind:selectable="selectable"
                  v-bind:show-actions="showActions"
                  v-bind:show-select-action="showBulkActions"
                  v-bind:tile="tile"
                  v-bind:tile-width="tileWidth"
                  v-for="tile in tiles"
                  v-if="tiles.length > 0"
            />
        </nav>

        <a class="btn btn-primary has-margin-r30 is-pulled-left"
           v-html="
                selectedTiles.length == paging.to - paging.from + 1
                ? __('Select none')
                : __('Select all')
           "
           v-if="showBulkActions && tiles.length > 0"
           v-on:click="selectAllTiles"
        ></a>

        <div class="tile-list__bulk-actions" v-if="showBulkActions && selectedTiles.length > 0">
            <a class="btn is-pulled-left"
               v-on:click="openDeleteConfirmModal('delete-selected-tiles')"
            >
                {{ __('Delete selected') }}
            </a>
            <confirm-modal
                    v-bind:id="'delete-selected-tiles'"
                    v-bind:text="__('Are you sure you wish to delete all selected tiles?')"
            ></confirm-modal>
        </div>

        <button class="btn is-primary tile-list__add-btn" type="button"
                v-if="listType == 'add' && tiles.length > 0 && selectedTiles.length > 0"
                v-on:click="handleAdd"
        >
            {{ __('Add to startdesk') }}
        </button>

        <p v-if="tiles.length == 0 && isLoading">{{ __('Loading tiles&hellip;') }}</p>
        <p v-if="tiles.length == 0 && !isLoading">{{ __('There are no tiles in this startdesk.') }}</p>

        <paging v-bind:paging="paging" v-if="showPaging"></paging>
    </div>
</template>

<script>
    import { eventBus } from '../eventBus.js';
    import { mixin as clickaway } from 'vue-clickaway';

    import categoryList from './CategoryList.vue';
    import confirmModal from '../elements/ConfirmModal.vue';
    import paging from '../elements/Paging.vue';
    import tile from './Tile.vue';

    export default {
        components: {
            categoryList,
            confirmModal,
            paging,
            tile
        },
        computed: {
            tileProperty: function () {
                const tileHeight = (this.tileWidth * 70 / 100) + 40;
                return 'height: ' + tileHeight + 'px; width: ' + this.tileWidth + 'px;';
            }
        },
        data: function () {
            return {
                categoryFilter: this.category,
                createdAt: {
                    start: null,
                    end: null
                },
                isLoading: false,
                paging: {
                    current: 1,
                    from: 1,
                    lastPage: 1,
                    perPage: this.showPaging ? 50 : 0,
                    to: 1,
                    total: 0
                },
                search: null,
                selectedTiles: [],
                sort: this.startdesk ? 'order' : 'name_asc',
                tileWidth: 130,
                tiles: [],
                updatedAt: {
                    start: null,
                    end: null
                },
                hideForScreenshot: false,
                startdesks: [],
                isStartdesksNavActive: false,
            }
        },
        methods: {
            getTiles: function (resetPaging = false) {
                this.tiles = [];
                if (resetPaging) {
                    this.paging.current = 1;
                }

                let filters = {};

                if (this.categoryFilter) {
                    filters.category = this.categoryFilter;
                }
                if (this.startdesk) {
                    filters.startdesk = this.startdesk.id;
                } else {
                    filters.startdesk = null;
                }

                if (this.createdAt) {
                    if (this.createdAt.start)
                        filters.creation_date_from = this.createdAt.start.getFullYear() + "-" + ("0"+(this.createdAt.start.getMonth()+1)).slice(-2) + "-" + ("0" + this.createdAt.start.getDate()).slice(-2) + ' 00:00';
                    if (this.createdAt.end)
                        filters.creation_date_to = this.createdAt.end.getFullYear() + "-" + ("0"+(this.createdAt.end.getMonth()+1)).slice(-2) + "-" + ("0" + this.createdAt.end.getDate()).slice(-2) + ' 23:59';
                }
                if (this.search) {
                    filters.search = this.search;
                }
                if (this.updatedAt) {
                    if (this.updatedAt.start)
                        filters.update_date_from = this.updatedAt.start.getFullYear() + "-" + ("0"+(this.updatedAt.start.getMonth()+1)).slice(-2) + "-" + ("0" + this.updatedAt.start.getDate()).slice(-2) + ' 00:00';
                    if (this.updatedAt.end)
                        filters.update_date_to = this.updatedAt.end.getFullYear() + "-" + ("0"+(this.updatedAt.end.getMonth()+1)).slice(-2) + "-" + ("0" + this.updatedAt.end.getDate()).slice(-2) + ' 23:59';
                }

                let sortBy = 'name';
                let sortOrder = 'asc';

                switch (this.sort) {
                    case 'name_asc':
                        sortBy = 'name';
                        sortOrder = 'asc';

                        break;
                    case 'name_desc':
                        sortBy = 'name';
                        sortOrder = 'desc';

                        break;
                    default:
                        sortBy = this.sort;
                        sortOrder = 'desc';
                }

                eventBus.$emit('show-loader');
                this.isLoading = true;

                this.$http.get(this.apiUrl + '/tiles', {
                    params : {
                        filters: filters,
                        page: this.paging.current,
                        perPage: this.paging.perPage,
                        sortBy: sortBy,
                        sortOrder: sortOrder
                    }
                }).then(function (response) {
                    this.paging.from = response.body.original.from;
                    this.paging.lastPage = response.body.original.last_page;
                    this.paging.to = response.body.original.to;
                    this.paging.total = response.body.original.total;
                    this.tiles = response.body.original.data;

                    eventBus.$emit('hide-loader');
                    this.isLoading = false;
                    this.$emit('tiles-loaded');
                }.bind(this), function (response) {
                    eventBus.$emit(
                        'show-alert',
                        'error',
                        this.__('There was an error retrieving data from the server.')
                    );

                    eventBus.$emit('hide-loader');
                    this.isLoading = false;
                }.bind(this));
            },
            handleAdd: function (e) {
                let promises = [];

                this.selectedTiles.forEach(function (tile) {

                    promises.push(this.$http.post(this.apiUrl + '/tiles', {
                        colors: {
                            textBackground: {
                                hex: tile.text_background
                            },
                            textColor: {
                                hex: tile.text_color
                            },
                            tileBackground: {
                                hex: tile.tile_background
                            },
                            tileColor: {
                                hex: tile.tile_color
                            }
                        },
                        is_active: 1,
                        is_affiliate: 0,
                        category_id: tile.category_id,
                        image_src: tile.image,
                        name: tile.name,
                        order: 0,
                        startdesk_id: this.activeStartdesk.id,
                        url: tile.url
                    }));
                }.bind(this));

                eventBus.$emit('show-loader');

                Promise.all(promises).then(function (response) {
                    eventBus.$emit('hide-loader');

                    eventBus.$emit('show-alert', 'success', this.__('Tiles successfully added to startdesk.'));
                    
                    setTimeout(function () {
                        this.$http.post(this.apiUrl + '/startdesks/' + this.activeStartdesk.id + '/screenshot');
                    }.bind(this), 1000);
                    
                    this.$router.push({
                        name: 'startdesks.view',
                        params: { startdesk: this.activeStartdesk.slug, u: this.activeStartdesk.is_user_startdesk }
                    });
                }.bind(this), function (response) {
                    if (response.status == 422 && response.body.errors) {
                        this.errors = response.body.errors;
                    }

                    eventBus.$emit('hide-loader');

                    eventBus.$emit(
                            'show-alert',
                            'error',
                            this.__('There were some errors validation the form. Please review and correct them.')
                    );
                }.bind(this));
            },
            handleReorder: function (dragged, target) {
                // dragged is the element that was dragged
                // target was the element that dragged was dropped onto
                // dragged should be placed before target
                if (dragged != target) {

                    var sortedTiles = [];
                    var draggedTile = null;

                    for (var i = 0; i < this.tiles.length; i++) {
                        if (dragged == this.tiles[i].id) {
                            draggedTile = this.tiles[i];
                            break;
                        }
                    }
                    this.tiles.forEach(function (tile) {
                        if (dragged != tile.id) {
                            if (target == tile.id) {
                                sortedTiles.push(draggedTile);
                            }

                            sortedTiles.push(tile);
                        }
                    });

                    this.tiles = sortedTiles;
                    this.$http.patch(this.apiUrl +  '/tiles/reorder', {
                        tiles: sortedTiles
                    });
                }
            },
            init: function () {
                this.getTiles(true);
                this.getStartdesks();
                
                if (document.cookie.includes('bbrchide')) {
                    this.hideForScreenshot = true;
                }
            },
            openDeleteConfirmModal: function (id) {
                eventBus.$emit('open-modal', id);
            },
            selectAllTiles: function () {
                if (this.selectedTiles.length == this.paging.to - this.paging.from + 1) {
                    eventBus.$emit('deselect-all-tiles');
                } else {
                    eventBus.$emit('select-all-tiles');
                }
            },
            updateCategory: function (category) {
                this.categoryFilter = category;
            },
            updatePaging: function (newPage, perPage) {
                if (newPage || perPage != this.paging.perPage) {
                    if (newPage) {
                        this.paging.current = newPage;
                    }
                    this.paging.perPage = perPage;

                    this.getTiles();
                }
            },
            handleAddToMyStartdesks: function (e) {
                let promises = [];
                
                promises.push(this.$http.put(this.apiUrl + '/startdesks/' + this.startdesk.id + '/' + this.user.id));

                eventBus.$emit('show-loader');

                Promise.all(promises).then(function (response) {
                    eventBus.$emit('hide-loader');

                    let newStartdesk = null;

                    response.forEach(function (item) {
                        this.myStartdesks.push(item.data);
                        newStartdesk = item.data;
                    }.bind(this));

                    this.myStartdesks.sort(function(a, b) {
                        return  a.name.localeCompare(b.name);
                    });

                    eventBus.$emit('show-alert', 'success', this.__('Startdesk successfully added to my startdesks.'));

                    this.viewStartdesk(newStartdesk);

                    this.$router.push({
                        name: 'startdesks.view',
                        params: { startdesk: newStartdesk.slug, u: newStartdesk.is_user_startdesk }
                    });
                }.bind(this), function (response) {
                    if (response.status == 422 && response.body.errors) {
                        this.errors = response.body.errors;
                    }

                    eventBus.$emit('hide-loader');

                    eventBus.$emit(
                            'show-alert',
                            'error',
                            this.__('There were some errors validation the form. Please review and correct them.')
                    );
                }.bind(this));
            },
            getStartdesks: function() {
                let filters = { user: this.user ? this.user.id : null };
                
                this.$http.get(this.apiUrl + '/startdesks', {
                    params : {
                        filters: filters,
                        sortBy: 'name',
                        sortOrder: 'asc',
                        perPage: 0,
                    }
                }).then(function (response) {
                    this.startdesks = response.body.original.data;
                }, function (response) {
                    this.startdesks = [];
                });
            },
            toggleStartdesksNav: function() {
                this.isStartdesksNavActive = !this.isStartdesksNavActive;
            },
            closeStartdesksNav: function() {
                this.isStartdesksNavActive = false;
            },
        },
        mixins: [
            clickaway
        ],
        mounted: function () {
            this.init();
        },
        props: {
            category: {
                default: null,
                type: Number
            },
            listType: {
                default: 'list',
                type: String
            },
            selectable: {
                default: false,
                type: Boolean
            },
            showActions: {
                default: true,
                type: Boolean
            },
            showAddButton: {
                default: true,
                type: Boolean
            },
            showBackButton: {
                default: false,
                type: Boolean
            },
            showBulkActions: {
                default: false,
                type: Boolean
            },
            showFilters: {
                default: null,
                type: Object
            },
            showPaging: {
                default: false,
                type: Boolean
            },
            showSort: {
                default: false,
                type: Boolean
            },
            showThumbnailSlider: {
                default: true,
                type: Boolean
            },
            showTitle: {
                default: true,
                type: Boolean
            },
            sortable: {
                default: false,
                type: Boolean
            },
            startdesk: {
                default: null,
                type: Object
            }
        },
        watch: {
            category: function () {
                this.categoryFilter = this.category;
            },
            categoryFilter: function () {
                this.getTiles(true);
            },
            startdesk: function () {
                this.getTiles();
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/TileList.vue